"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../styles");
exports.SPACINGS = [1, 2, 3, 4];
const styles = styles_1.createStyles(({ spacing }) => (Object.assign({ container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
    }, item: {}, noWrap: {
        flexWrap: 'nowrap',
    }, overflowing: {
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        willChange: 'scroll-position',
        backfaceVisibility: 'hidden',
    }, zeroMinWidth: {
        minWidth: 0,
    } }, exports.SPACINGS.reduce((acc, value) => (Object.assign(Object.assign({}, acc), { [`spacing-${value}`]: {
        width: `calc(100% + ${spacing(value)})`,
        margin: spacing((value / 2) * -1),
        [`& > $item:not(:empty)`]: {
            padding: spacing(value / 2),
        },
    } })), {}))));
exports.decorate = styles_1.withStyles(styles, { injectTheme: true });
